import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useBonusesSelector } from '../redux/reducers/app/configuration';
import {
  useIsWageringGamesAvailable,
  useCollectingGamesCampaignId,
} from './API/useQueryBonuses';

export const useBonusAvailabilityParams = () => {
  const isWageringGamesAvailable = useIsWageringGamesAvailable();
  const { id: collectingGamesCampaignId } = useCollectingGamesCampaignId();
  const isCollectingGamesAvailable = Boolean(collectingGamesCampaignId);
  const hasBonuses = useSelector(useBonusesSelector);

  return useMemo(
    () => ({
      hasBonuses,
      hasBonusCollectingGames: isCollectingGamesAvailable,
      hasBonusWageringGames: isWageringGamesAvailable,
    }),
    [hasBonuses, isCollectingGamesAvailable, isWageringGamesAvailable]
  );
};

export default useBonusAvailabilityParams;
